import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import metricsServices from '@/metrics/services/services'

import { transformResponsePerformanceInsightsNumbers } from './transformers'

const usePerformanceInsightsNumbers = ({ storeId, startDate, endDate }) => {
  const [settledRequest, setSettledRequest] = useState()

  const { data, loading, fetchDataCancellable } = useFetch(metricsServices.getPerformanceInsightsNumbers, {
    doInitialRequest: false,
    transformResponse: transformResponsePerformanceInsightsNumbers,
  })

  const requestKey = `${storeId}-${startDate}-${endDate}`
  const isRequestSettled = settledRequest?.key === requestKey

  const refetchWhenArgsChange = () => {
    fetchDataCancellable(
      { storeId, params: { start_date: startDate, end_date: endDate } },
      () => setSettledRequest({ key: requestKey, hasError: false }),
      () => setSettledRequest({ key: requestKey, hasError: true })
    )
  }

  useEffect(refetchWhenArgsChange, [endDate, fetchDataCancellable, requestKey, startDate, storeId])

  return {
    numbers: data,
    fetchingNumbers: loading || !isRequestSettled,
    numbersError: isRequestSettled && settledRequest.hasError,
  }
}

export default usePerformanceInsightsNumbers
